import React from 'react';
import { Box, Text } from '@chakra-ui/react';

import { useBannerSize } from '../hooks/use-banner-size';

type DataCellProps = {
  value: string;
  suffix?: string;
  prefix?: string;
  label: string;
  valueTestId?: string;
};

export function DataCell({ value, suffix, prefix, label, valueTestId }: DataCellProps) {
  const { fontSize } = useBannerSize();
  return (
    <>
      <Box fontSize={fontSize} _dark={{ color: 'white' }} data-testid={valueTestId}>
        {prefix && (
          <Box as="span" fontSize="14px" fontWeight="normal">
            {prefix}
          </Box>
        )}
        {value}
        {suffix && (
          <Box as="span" fontSize="14px" fontWeight="normal">
            {' '}
            {suffix}
          </Box>
        )}
      </Box>
      <Text fontSize="12px">{label}</Text>
    </>
  );
}
